import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * @component PrivateRoute
 * @description Um componente de ordem superior que funciona como um "guardião" para rotas.
 * Ele verifica o estado de autenticação do utilizador antes de permitir o acesso
 * a uma rota protegida.
 */
const PrivateRoute = () => {
  // --- HOOKS E CONTEXTO ---
  // Utiliza o nosso hook personalizado `useAuth` para aceder ao estado de autenticação.
  // A variável `isAuthenticated` será `true` se o utilizador estiver logado, e `false` caso contrário.
  const { isAuthenticated } = useAuth();

  // --- LÓGICA DE RENDERIZAÇÃO ---

  // A lógica é simples:
  // 1. Se `isAuthenticated` for `true`, o componente <Outlet /> é renderizado.
  //    O <Outlet /> é um marcador de posição do React Router que renderiza o
  //    componente filho correspondente à rota atual (ex: <Dashboard />, <ToolList />, etc.).
  //
  // 2. Se `isAuthenticated` for `false`, o componente <Navigate> é renderizado.
  //    Ele redireciona o utilizador para a página de login ("/login").
  //    A propriedade `replace` é importante: ela substitui a entrada atual no histórico
  //    de navegação, impedindo que o utilizador use o botão "voltar" do navegador
  //    para aceder à página protegida que acabou de ser bloqueada.
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
